import { useIntl } from 'react-intl-next';

import { fg } from '@confluence/feature-gating';
import { AccessStatus, useSessionDataWithRovoExperiment } from '@confluence/session-data';

export const useIsEligibleRovoAwareness = (): boolean => {
	const { isLoggedIn, isRovoLLMEnabled, accessStatus } = useSessionDataWithRovoExperiment();
	const { locale } = useIntl();

	const isRovoEnabled =
		isRovoLLMEnabled && isLoggedIn && accessStatus !== AccessStatus.EXTERNAL_COLLABORATOR_ACCESS;

	// Will remove this after translation is ready
	// https://hello.jira.atlassian.cloud/browse/CFFD-871
	const isEnglishLocale = locale.toLowerCase().startsWith('en');

	return isRovoEnabled && isEnglishLocale && fg('rovo_awareness_enabled');
};
